import React__default from 'react';
import DefaultIcon from '../DefaultIcon/index.js';
import FormatTechnicalFolder from './FormatTechnicalFolder.js';

var DisplayMode;
(function (DisplayMode) {
    DisplayMode["ALL_FOLDERS_WITH_LINKS"] = "ALL_FOLDERS_WITH_LINKS";
    DisplayMode["ALL_FOLDERS_WITHOUT_LINKS"] = "ALL_FOLDERS_WITHOUT_LINKS";
    DisplayMode["FIRST_FOLDER_WITH_LINK"] = "FIRST_FOLDER_WITH_LINK";
    DisplayMode["FIRST_FOLDER_WITHOUT_LINK"] = "FIRST_FOLDER_WITHOUT_LINK";
})(DisplayMode || (DisplayMode = {}));
var FormatTechnicalFolders = function (_a) {
    var folders = _a.folders, displayMode = _a.displayMode, onFolderClick = _a.onFolderClick, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b;
    if (!folders || folders.length < 1) {
        return React__default.createElement(React__default.Fragment, null);
    }
    switch (displayMode) {
        case DisplayMode.ALL_FOLDERS_WITH_LINKS:
        case DisplayMode.ALL_FOLDERS_WITHOUT_LINKS:
            return (React__default.createElement(React__default.Fragment, null, folders.map(function (folder) { return (React__default.createElement(FormatTechnicalFolder, { folder: folder, key: folder.id, onFolderClick: displayMode === DisplayMode.ALL_FOLDERS_WITH_LINKS ? onFolderClick : undefined, KIcon: KIcon })); })));
        case DisplayMode.FIRST_FOLDER_WITH_LINK:
        case DisplayMode.FIRST_FOLDER_WITHOUT_LINK:
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(FormatTechnicalFolder, { truncateTitleLargerThan: 25, folder: folders[0], key: folders[0].id, onFolderClick: displayMode === DisplayMode.FIRST_FOLDER_WITH_LINK ? onFolderClick : undefined, KIcon: KIcon })));
        default:
            return null;
    }
};

export { DisplayMode, FormatTechnicalFolders as default };
//# sourceMappingURL=FormatTechnicalFolders.js.map
